import { type CreateMessage, api } from '@here/api'
import { v4 } from 'uuid'

// TODO add error handling so it deletesall the files if there is an error
// TODO add in success handler so that only on success do we clear the message
export const whenInsertMessage = async (message?: CreateMessage) => {
	if (!message) return

	const parser = new DOMParser()
	const doc = parser.parseFromString(message.content, 'text/html')

	const imgElements = Array.from(doc.querySelectorAll('img'))
	const audioElements = Array.from(doc.querySelectorAll('audio'))
	const mentions = Array.from(doc.querySelectorAll('.mention-blot'))

	// Process images
	await Promise.all(
		imgElements.map(async (img) => {
			const src = img.getAttribute('src')
			if (!src || !src.startsWith('data:image')) return

			const mimeMatch = src.match(/^data:(image\/[a-zA-Z]+);base64,/)
			if (!mimeMatch) return

			const mime = mimeMatch[1]
			const fileExt = mime.split('/')[1]
			const base64Data = src.split(',')[1]
			const byteChars = atob(base64Data)
			const byteNumbers = Array.from(byteChars, (c) => c.charCodeAt(0))
			const byteArray = new Uint8Array(byteNumbers)
			const blob = new Blob([byteArray], { type: mime })

			const fileName = `${message.channel_id}/${v4()}.${fileExt}`

			const { error: uploadError } = await api()
				.storage.from('channel-files')
				.upload(fileName, blob, { contentType: mime })

			if (uploadError) {
				throw new Error(`Image upload failed: ${uploadError.message}`)
			}

			img.setAttribute('src', fileName)
		}),
	)

	// Process audio clips
	await Promise.all(
		audioElements.map(async (audio) => {
			const src = audio.getAttribute('src')
			if (!src || !src.startsWith('blob:')) return

			try {
				const response = await fetch(src)
				const blob = await response.blob()

				const mime = blob.type || 'audio/webm'
				const ext = mime.split('/')[1] || 'webm'
				const fileName = `${message.channel_id}/${v4()}.${ext}`

				const { error: uploadError } = await api()
					.storage.from('channel-files')
					.upload(fileName, blob, { contentType: mime })

				if (uploadError) {
					throw new Error(`Audio upload failed: ${uploadError.message}`)
				}

				audio.setAttribute('src', fileName)
			} catch (err) {
				console.error('Failed to process audio:', err)
			}
		}),
	)

	// loop through the content, find all the mentions and then
	// create new mentions in the mention table using the activeMentions list

	const updatedContent = doc.body.innerHTML

	const { data, error } = await api()
		.from('message')
		.insert({
			...message,
			content: updatedContent,
		})
		.select()
		.single()

	if (error) throw new Error(error.message)

	// Insert mentions
	await Promise.all(
		mentions.map(async (mention) => {
			const userId = mention.getAttribute('data-mention-id')
			const username = mention.getAttribute('data-mention-username')

			if (!userId || !username) return

			const { error: mentionError } = await api().from('message_mention').insert({
				user_id: userId,
				message_id: data.id,
				channel_id: message.channel_id,
				username: username,
			})

			if (mentionError) {
				console.error('Failed to insert mention:', mentionError)
			}
		}),
	)

	return data
}
